import Vue from 'vue';
import VeeValidate from 'vee-validate';
import {
  MdField, MdContent, MdDivider, MdRadio,
  MdCheckbox, MdDatepicker, MdMenu, MdList,
  MdButton, MdDialog, MdSnackbar, MdDialogConfirm,
  MdProgress, MdDialogAlert,
} from 'vue-material/dist/components';
import VueMq from 'vue-mq';

// I18n 1/2
import VueI18n from 'vue-i18n';

// import VueMaterial from 'vue-material';
import RangeSlider from 'vue-range-slider';
import App from './App.vue';
import router from './router';
import store from './store';
import ApiService from './services/api.service';

// I18n 2/2
import En from './i18n/en.json';
import Pl from './i18n/pl.json';

// Vue material design components styles import
import 'vue-material/dist/vue-material.min.css';
import 'vue-range-slider/dist/vue-range-slider.css';

// Internal components import
import Button from './components/Button/Button.vue';
import File from './components/File/File.vue';
import Skeleton from './components/Skeleton/Skeleton.vue';
import SurveyRootNode from './components/SurveyRootNode/SurveyRootNode.vue';
import SurveyField from './components/SurveyField/SurveyField.vue';
import SurveyGroup from './components/SurveyGroup/SurveyGroup.vue';
import SurveyLabel from './components/SurveyLabel/SurveyLabel.vue';
import SurveyList from './components/SurveyList/SurveyList.vue';
import SurveyExercises from './components/SurveyExercises/SurveyExercises.vue';
import SurveyRecognitions from './components/SurveyRecognitions/SurveyRecognitions.vue';
import SurveyMultiline from './components/SurveyMultiline/SurveyMultiline.vue';
import SurveyText from './components/SurveyText/SurveyText.vue';
import SurveyInt from './components/SurveyInt/SurveyInt.vue';
import SurveyRange from './components/SurveyRange/SurveyRange.vue';
import SurveySlider from './components/SurveySlider/SurveySlider.vue';
import SurveyRadioGroup from './components/SurveyRadioGroup/SurveyRadioGroup.vue';
import SurveyCheckbox from './components/SurveyCheckbox/SurveyCheckbox.vue';
import SurveyDropdownGroup from './components/SurveyDropdownGroup/SurveyDropdownGroup.vue';
import SurveyDatepicker from './components/SurveyDatepicker/SurveyDatepicker.vue';
import InvalidToken from './components/InvalidToken/InvalidToken.vue';

// Vue material design components declaration
Vue.use(MdField);
Vue.use(MdContent);
Vue.use(MdDivider);
Vue.use(MdRadio);
Vue.use(MdCheckbox);
Vue.use(MdDatepicker);
Vue.use(MdMenu);
Vue.use(MdList);
Vue.use(MdButton);
Vue.use(MdDialog);
Vue.use(MdDialogAlert);
Vue.use(MdDialogConfirm);
Vue.use(MdSnackbar);
Vue.use(MdProgress);

Vue.use(VeeValidate);
Vue.use(VueI18n);
Vue.use(VueMq, {
  breakpoints: {
    xs: 700,
    sm: 1100,
    md: 1380,
    lg: 1920,
    xl: Infinity,
  },
});

ApiService.init();

Vue.config.productionTip = false;

Vue.component('btn', Button);
Vue.component('skeleton', Skeleton);
Vue.component('file', File);
Vue.component('survey-field', SurveyField);
Vue.component('survey-group', SurveyGroup);
Vue.component('survey-label', SurveyLabel);
Vue.component('survey-list', SurveyList);
Vue.component('survey-root-node', SurveyRootNode);
Vue.component('survey-exercises', SurveyExercises);
Vue.component('survey-recognitions', SurveyRecognitions);
Vue.component('survey-multiline', SurveyMultiline);
Vue.component('survey-text', SurveyText);
Vue.component('survey-int', SurveyInt);
Vue.component('survey-range', SurveyRange);
Vue.component('range-slider', RangeSlider);
Vue.component('survey-slider', SurveySlider);
Vue.component('survey-radio-group', SurveyRadioGroup);
Vue.component('survey-checkbox', SurveyCheckbox);
Vue.component('survey-dropdown-group', SurveyDropdownGroup);
Vue.component('survey-datepicker', SurveyDatepicker);
Vue.component('invalid-token', InvalidToken);

export const messages = {
  'en-En': En,
  'pl-Pl': Pl,
};

export const i18n = new VueI18n({
  locale: 'pl-Pl',
  fallbackLocale: 'pl-Pl',
  messages,
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>',
  data() {
    return {
      alertDialog: {
        active: false,
        title: '',
        content: '',
      },
      confirmDialog: {
        active: false,
        title: '',
        content: '',
        onConfirm: () => {},
        onCancel: () => {
          this.confirmDialog = () => {};
        },
      },
    };
  },
});

Vue.material.locale = {
  startYear: 1900,
  endYear: 2099,
  dateFormat: 'YYYY-MM-DD',
  days: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
  shortDays: ['Ndz', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'So'],
  shorterDays: ['N', 'P', 'W', 'Ś', 'C', 'P', 'S'],
  months: ['Styczeń', 'Luty', 'Marzec', 'Kwieceń', 'Maj', 'Czerwiec', 'Lipiec', 'Śierpień',
    'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
  shortMonths: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
  shorterMonths: ['S', 'L', 'M', 'K', 'Ma', 'C', 'L', 'Ś', 'W', 'P', 'Li', 'G'],
  firstDayOfAWeek: 0,
};



// WEBPACK FOOTER //
// ./src/main.js